import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/MultiStepForm.css';
import enterArrow from '../assets/send-icon.svg';
import logo from '../assets/loving-is-logo.png'; 
import mobileLlogo from '../assets/loving-home-logo.png'

const SOCKET_SERVER_URL = process.env.REACT_APP_BACKEND_URL;
const API_SERVER_URL = `${SOCKET_SERVER_URL}`;

const MultistepForm = () => {
    const [input, setInput] = useState('');
    const [successMessage, setSuccessMessage] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const navigate = useNavigate()

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };

    const isMobile = windowWidth < 768; 
  const logoToDisplay = isMobile ? mobileLlogo : logo;

    const handleSubmit = async () => {
        if (!input.trim()) return;

        try {
            const response = await fetch(`${API_SERVER_URL}/api/waitlist`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: input }),
            });

            if (response.ok) {
                setSuccessMessage('Thank you for joining the waitlist. We’ll be in touch.');
                setInput(''); // Clear input after success
                navigate('/thank-you')
            } else {
                alert('Failed to submit email. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting email:', error);
            alert('Something went wrong.');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <div className="multistep-form-container">
            <div className='home-page-container'>

            <h1 className="welcome-text">Welcome To</h1>
            <div className="logo-container">
  <div className="logo-desktop">
    <img src={logo} alt="Loving Is" />
  </div>
  <div className="logo-mobile">
    <img src={mobileLlogo} alt="Loving Is" className='logo-m' />
  </div>
</div>
            <p className="description-text">
                This page is accessible by invitation only. <br/> Please provide your email to join the waitlist.
            </p>
            <div className="form-step">
                <input
                    type="email"
                    value={input}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Enter your email"
                />
                <img
                    src={enterArrow}
                    alt="Submit"
                    onClick={handleSubmit}
                    className={`submit-arrow ${!input.trim() ? 'disabled' : ''}`}
                />
            </div>

            {successMessage && <p className="success-message">{successMessage}</p>}
        </div>
        </div>
    );
};

export default MultistepForm;
